export class CloudAccountNotificationArguments {
    'providerAccountId';
    'projectId';
    'type';
    'cloudProvider';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerAccountId",
            "baseName": "providerAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "projectId",
            "baseName": "projectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "CloudAccountType",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CloudAccountNotificationArguments.attributeTypeMap;
    }
    constructor() {
    }
}
